import { render, staticRenderFns } from "./ContactPreferenceDialog.vue?vue&type=template&id=47b5a697&"
import script from "./ContactPreferenceDialog.vue?vue&type=script&lang=js&"
export * from "./ContactPreferenceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports